import type { SVGProps } from 'react';

const SvgUpsell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="up-sell">
      <path d="M30.37 18.16a.75.75 0 0 0-.11-.8L16.27.8a.76.76 0 0 0-1.14 0l-14 16.56a.75.75 0 0 0-.11.8.76.76 0 0 0 .68.43h5.09v10.13a2.75 2.75 0 0 0 2.75 2.75h12.33a2.76 2.76 0 0 0 2.75-2.75V18.59h5.07a.75.75 0 0 0 .68-.43Zm-6.5-1.07a.75.75 0 0 0-.75.75v10.88A1.25 1.25 0 0 1 21.87 30H9.54a1.25 1.25 0 0 1-1.25-1.25V17.84a.76.76 0 0 0-.75-.75H3.33L15.7 2.44l12.37 14.65Z" />
      <path d="M15 9.79v1.63h-.36a3 3 0 0 0 0 5.94H15v2.94h-.47a1.34 1.34 0 0 1-1.38-1.3h-1.5a2.84 2.84 0 0 0 2.83 2.84H15v1.62h1.5V21.8h.36a3 3 0 0 0 0-5.94h-.36v-2.94h.47a1.32 1.32 0 0 1 1.33 1.33v.37h1.5v-.37a2.83 2.83 0 0 0-2.83-2.83h-.47V9.79Zm1.86 7.57a1.47 1.47 0 0 1 0 2.94h-.36v-2.94ZM15 15.86h-.36a1.46 1.46 0 0 1-1.44-1.5 1.44 1.44 0 0 1 1.44-1.44H15Z" />
    </g>
  </svg>
);

export default SvgUpsell;
